// @flow

import type { RouterHistory } from 'react-router-dom';

import {
  agentHomeLatestUsers,
  agentLatestHomeQuotesSearch,
  featureFlag,
  homeLatestPolicyCode, homePromoCodeValidate,
  motorDocuments, targetGateway,
  travelDocuments,
  updateNumber,
  verified
} from '../../constants/apiRequest/requestConstants/endpoints';
import { CAR_INSURANCE_TYPE } from '../../constants/insuranceTypeConstants';
import { AGENT_SELECTED_QUOTE } from '../../constants/sessionStorage/userStorageIdentifiers';
import { saveObjectInSessionStorage } from '../../helpers';
import { makeRequest } from '../../helpers/makeApiRequest';
import type { GetPolicyDocumentResponse } from '../../types/commonTypes';

export const getGenericDocumentLinks = async (
  insuranceType: string,
  policyReference: string,
  history: RouterHistory
): Promise<GetPolicyDocumentResponse> => {

  const carInsurancePolicy = insuranceType === CAR_INSURANCE_TYPE;
  const url = `${carInsurancePolicy ? motorDocuments : travelDocuments}?policyReference=${policyReference}`;

  return makeRequest({
    url: url,
    method: 'GET',
    history
  });
};

export const updateUserAttribute = async (
  // eslint-disable-next-line flowtype/no-weak-types
  phoneNumber: any,
  // eslint-disable-next-line flowtype/no-weak-types
  userName: any,
  // eslint-disable-next-line flowtype/no-weak-types
  props: any = {}
) => {
  return await makeRequest({
    method: 'PUT',
    url: updateNumber,
    history: props.history,
    payload: {
      user_name: userName,
      phone_number: phoneNumber
    }
  });
};

export const getDocument = async (
  // eslint-disable-next-line flowtype/no-weak-types
  payload: any,
  url: string,
  // eslint-disable-next-line flowtype/no-weak-types
  props: Object = {}
) => {
  return makeRequest({
    method: 'POST',
    url: url,
    payload: {
      document_id: payload
    },
    history: props.history
  });
};

export const getFeatureFlags = async () => {
  return makeRequest({
    method: 'GET',
    url: featureFlag
  });
};

export const isVerifiedUser = async (email: string) => {
  const response = await makeRequest({
    method: 'POST',
    url: verified,
    payload: {
      email: email
    }
  });

  return response?.error ? {
    mfa_enabled: false,
    number_verified: false
  } : response;
};

// eslint-disable-next-line flowtype/no-weak-types
/*
export const collateUserSearchResults = async (values: any, userList: any) => {
  if (userList.pagination_token && userList.pagination_token.length > 0) {
    let continuedRequest = await makeRequest({
      method: 'POST',
      url: `${basePath}/home/applied_home_quotes/user_latest_quotes`,
      payload: {
        [PAYLOADVALUE[`${values.dropdownValue}`]]: values.searchInput,
        starts_with: true,
        limit: 10,
        pagination_token: userList.pagination_token
      }
    });
    // eslint-disable-next-line require-atomic-updates
    userList.user_quote_map = {
      ...userList.user_quote_map,
      ...continuedRequest.user_quote_map
    };
    // eslint-disable-next-line require-atomic-updates
    userList.pagination_token = continuedRequest.pagination_token;
    await collateUserSearchResults(values, userList);
  } else {
    if (getObjectFromSessionStorage(USER_QUOTE_LIST)) {
      removeFromSessionStorage(USER_QUOTE_LIST);
    }
    saveObjectInSessionStorage(USER_QUOTE_LIST, userList);
  }
};
 */

// eslint-disable-next-line flowtype/no-weak-types
export const getLatestQuoteUsers = async (values: any) => {
  const response = await makeRequest({
    method: 'POST',
    url: agentHomeLatestUsers,
    payload: {email: values.searchInput}
  });

  return response?.error ? [] : response;
};

export const getLatestQuoteForPolicyCode = async (policyCode: string) => {
  const response = await makeRequest({
    method: 'GET',
    url: `${targetGateway()}${homeLatestPolicyCode}?policyCode=${policyCode}`
  });

  if (response?.error) return [];

  saveObjectInSessionStorage(AGENT_SELECTED_QUOTE, response);
};

export const getLatestHomeQuotesByType = async (
  // eslint-disable-next-line flowtype/no-weak-types
  request: any,
  // eslint-disable-next-line flowtype/no-weak-types
  page_number: any,
  // eslint-disable-next-line flowtype/no-weak-types
  page_size: any,
  // eslint-disable-next-line flowtype/no-weak-types
  type: any
): Promise<any> => {
  const response = await makeRequest({
    method: 'POST',
    url: agentLatestHomeQuotesSearch,
    payload: {
      search_criteria: request,
      search_type: type,
      page_number: page_number,
      page_size: page_size
    }
  });

  return response?.error ? [] : response;
};

export const validatePromoAlias = async (alias: string) => {
  const requestUrl = `${homePromoCodeValidate}${alias}`;
  const validatePromoResponse = await makeRequest({
    method: 'GET',
    url: requestUrl
  });
  return validatePromoResponse?.error ? false : validatePromoResponse;
};
